<template>
  <canvas ref="canvas" style="width: 100%; height: 100%; display: block;"></canvas>
</template>

<script>
import ChartJs from 'chart.js'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'

let default_option = {
  responsive: true,
  maintainAspectRatio: false, // <-- 關鍵，讓圖表可拉伸填滿父容器
  tooltips: {
    enabled: false,
    custom: CustomTooltips,
    intersect: true,
    mode: 'index',
    position: 'nearest',
    callbacks: {
      labelColor: function (tooltipItem, chart) {
        return {
          backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor
        }
      }
    }
  },
  scales: {
    yAxes: [{
      scaleLabel: {
        display: true,
        labelString: 'kW'
      },
      ticks: {
        beginAtZero: true
      }
    }],
    xAxes: [{
      scaleLabel: {
        display: true,
        labelString: '時間'
      }
    }]
  }
};

export default {
  name: 'HistoryMixedChart',
  props: ['title', 'data', 'options'],
  data () {
    return {
      chart: null,
      resizeObserver: null
    }
  },
  mounted () {
    this.renderCustomChart();

    //當容器大小變動時，自動觸發圖表 resize
    this.resizeObserver = new ResizeObserver((entries) => {
      //console.log('Resize triggered:', entries[0].contentRect.width)
      if (this.chart) {
        this.chart.resize();
        this.chart.update(0) // 強制重新 render
      }
    })
    this.resizeObserver.observe(this.$el);
  },
  beforeDestroy () {
    if (this.chart) {
      this.chart.destroy();
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  watch: {
    data () {
      this.renderCustomChart();
    }
  },
  methods: {
    renderCustomChart () {
      if (this.chart) {
        this.chart.destroy();
      }

      const ctx = this.$refs.canvas.getContext('2d');
      // 先複製 options，避免修改原始 prop
      const chartOptions = Object.assign({}, this.options || default_option);

      // 加上 title
      chartOptions.title = {
        display: true,
        text: this.title || '',       // this.title 是你傳入的 prop
        fontSize: 16,
        fontColor: '#ffffff',
      };

      this.chart = new Chart(ctx, {
        type: 'bar', // 使用 bar 做為 base，但 datasets 可混合 type
        data: this.data,
        options: chartOptions
      });
    },
    updateYAxisMax(maxValue) {
      if (this.chart && this.chart.options && this.chart.options.scales) {
        this.chart.options.scales.yAxes.forEach(axis => {
          axis.ticks.max = maxValue;
        });
        this.chart.update();
      }
    }
  }
}
</script>